export default "__VITE_ASSET__r1QsO94B__"